import { render, staticRenderFns } from "./purchase-cancel.vue?vue&type=template&id=0bf4d9b6&"
import script from "./purchase-cancel.vue?vue&type=script&lang=js&"
export * from "./purchase-cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports